<template>
    <rkm-table
        :fields="fields"
        :items="model.exames"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(codigo)="{item}">
            {{item.exame.codigoProcedimento ? formatProcedimento(item.exame.codigoProcedimento) : item.exame.codigoEsus}}
        </template>

        <template v-slot:cell(actions)="{index}">
            <rkm-button
                @click="destroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

export default {
    data: () => ({
        fields: [
            {class: 'col-min', key: 'codigo', label: 'Código'},
            {key: 'exame.descricao', label: 'Descrição'},
            {formatter: (value) => value ? 'Sim' : 'Não', key: 'solicitado', label: 'Solicitado'},
            {formatter: (value) => value ? 'Sim' : 'Não', key: 'avaliado', label: 'Avaliado'},
            {class: 'col-min', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o exame?', async () => {
                this.model.exames.splice(index, 1)
            })
        },
    },
    mixins: [formats],
    props: {
        model: {type: Object, required: true},
    },
};
</script>
